import "@fontsource/oswald";
import FooterBlue from '../../components/FooterBlue';
import HeaderBlue from '../../components/HeaderBlue';

const TruckersForum = () => {
    const toggleQuestion = (e) => {
        const clickedDiv = e.currentTarget;
        const content = clickedDiv.nextElementSibling;
        const icon = clickedDiv.querySelector('i');

        content.classList.toggle('hidden');
        icon.classList.toggle('fa-chevron-down');
        icon.classList.toggle('fa-chevron-up');
    };

    return (
        <div className="font-oswald">
            <HeaderBlue />
            {/* Hero Banner */}
            <section className="w-full py-60 relative bg-cover bg-top px-3"
                style={{
                    backgroundImage: "url('./assets/truckersforum2.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-oswald drop-shadow-lg pb-5">TRUCKERS FORUM</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        Join our community to ask questions, share insights, and connect with truck<br />
                        drivers and carriers. All posts are reviewed by admins for quality and relevance.
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <main className="container max-w-4xl mx-auto px-4 py-12">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-deep-red mb-4">Truckers Forum</h2>
                    <p className="text-gray-600  max-w-2xl mx-auto">
                        Join our community to ask questions, share insights, and connect with drivers and carriers. All
                        posts are reviewed by admins for quality and relevance.
                    </p>
                </div>

                <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-12">
                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-deep-red mb-4">Ask a Question</h3>
                        <form className="space-y-4">
                            <textarea
                                placeholder="Type your question here..."
                                required
                                className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-deep-red min-h-[120px]"
                            ></textarea>
                            <button
                                type="submit"
                                className="bg-deep-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-deep-blue-dark transition"
                            >
                                Submit Question
                            </button>
                            <p className="text-gray-500 text-sm">Your question will be visible after admin approval.</p>
                        </form>
                    </div>

                    <div className="space-y-6">
                        {/* Question 1 */}
                        <div className="bg-light-gray rounded-xl overflow-hidden border border-gray-200">
                            <div
                                className="p-4 md:p-6 flex justify-between items-center cursor-pointer hover:bg-blue-50 transition"
                                onClick={toggleQuestion}
                            >
                                <div>
                                    <h4 className="text-xl font-semibold">What are the best tips for new drivers?</h4>
                                    <p className="text-gray-500 text-sm">Asked by Michael Johnson (Driver) on May 15, 2025</p>
                                </div>
                                <i className="fas fa-chevron-down text-deep-red text-xl"></i>
                            </div>
                            <div className="hidden bg-white p-4 md:p-6">
                                <div className="mb-6">
                                    <p className="text-gray-700">
                                        I'm just starting out as a truck driver. What advice would you give to someone new to the industry?
                                    </p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-light-gray p-4 rounded-lg border border-gray-200">
                                        <p className="text-gray-700">
                                            Always plan your route ahead and check for road closures. Get plenty of rest and stay organized with your logs.
                                        </p>
                                        <p className="text-gray-500 text-sm mt-2">Answered by Sarah Smith (Driver) on May 16, 2025</p>
                                    </div>

                                    <div className="bg-light-gray p-4 rounded-lg border border-gray-200">
                                        <p className="text-gray-700">
                                            Learn to manage your time well. Prioritize safety and don't rush deliveries.
                                        </p>
                                        <p className="text-gray-500 text-sm mt-2">Answered by ABC Transport (Carrier) on May 17, 2025</p>
                                    </div>
                                </div>

                                <form className="space-y-4">
                                    <textarea
                                        placeholder="Write your answer..."
                                        required
                                        className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-deep-red min-h-[100px]"
                                    ></textarea>
                                    <button
                                        type="submit"
                                        className="bg-deep-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-deep-blue-dark transition"
                                    >
                                        Submit Answer
                                    </button>
                                    <p className="text-gray-500 text-sm">Your answer will be visible after admin approval.</p>
                                </form>
                            </div>
                        </div>

                        {/* Question 2 */}
                        <div className="bg-light-gray rounded-xl overflow-hidden border border-gray-200">
                            <div
                                className="p-4 md:p-6 flex justify-between items-center cursor-pointer hover:bg-blue-50 transition"
                                onClick={toggleQuestion}
                            >
                                <div>
                                    <h4 className="text-xl font-semibold">How to find reliable drivers for my company?</h4>
                                    <p className="text-gray-500 text-sm">Asked by Jane Wilson (Carrier) on May 10, 2025</p>
                                </div>
                                <i className="fas fa-chevron-down text-deep-red text-xl"></i>
                            </div>
                            <div className="hidden bg-white p-4 md:p-6">
                                <div className="mb-6">
                                    <p className="text-gray-700">
                                        Our company struggles to find dependable drivers. Any strategies to attract and retain good talent?
                                    </p>
                                </div>

                                <div className="space-y-4 mb-6">
                                    <div className="bg-light-gray p-4 rounded-lg border border-gray-200">
                                        <p className="text-gray-700">
                                            Offer competitive pay and benefits. Also, create a positive work culture where drivers feel valued.
                                        </p>
                                        <p className="text-gray-500 text-sm mt-2">Answered by Mike Brown (Carrier) on May 11, 2025</p>
                                    </div>
                                </div>

                                <form className="space-y-4">
                                    <textarea
                                        placeholder="Write your answer..."
                                        required
                                        className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-deep-red min-h-[100px]"
                                    ></textarea>
                                    <button
                                        type="submit"
                                        className="bg-deep-red text-white px-6 py-3 rounded-lg font-semibold hover:bg-deep-blue-dark transition"
                                    >
                                        Submit Answer
                                    </button>
                                    <p className="text-gray-500 text-sm">Your answer will be visible after admin approval.</p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <FooterBlue />
        </div>
    );
};

export default TruckersForum;